import store from '@/store';
import { ToastProgrammatic as Toast } from 'buefy'; // just until better response interceptor.
import { SnackbarProgrammatic as Snackbar } from 'buefy';

const axios = require('axios').create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
    }
});

// ----------------------------------------------------
// START Configure Interceptors
// ----------------------------------------------------

axios.interceptors.request.use(
    function (config) {
        const token = store.state.accessToken;
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    function (error) {
        // Should only ever happen in development!?
        window.console && console.log("Error in axios request interceptor.");
        window.console && console.log(error);
    }
);

axios.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        let error_string;
        let validationMessage = '';
        // @todo - better error handling.
        // https://github.com/axios/axios#handling-errors
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    error_string = "Session expired: Please revalidate.";
                    break;
                case 403:
                    error_string = "You do not have access to do that.";
                    break;
                case 422:
                    validationMessage = 'Submitted data did not pass validation:<br><ul>';
                    for(var key in error.response.data.error){
                        validationMessage+='<li>'+error.response.data.error[key]+'</li>'
                    }
                    validationMessage+='</ul>'
                    Snackbar.open({
                        message: validationMessage,
                        type:'is-danger',
                        queue:false,
                        indefinite:true,
                        position:'is-top',
                        actionText:'OK'
                    })
                    break;
                default:
                    error_string = `${error.response.data.error}.`;
                    break;
            }
        }
        else if (error.request) {
            error_string = "No response from remote server.";
        }else{
            error_string = `Request error: ${error.message}`;
        }

        if (error_string) {
            Toast.open({
                type: 'is-danger',
                message: error_string
            });
        }
        return Promise.reject(error);
    }
);

// ----------------------------------------------------
// END Configure Interceptors
// ----------------------------------------------------

export default axios;